<template>
    <el-dialog
        class="edit"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Edit"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="editForm" :model="editForm" @keydown.enter.native.prevent>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Name" prop="name" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="editForm.name"
                                placeholder="Name"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Key" prop="key" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="editForm.key"
                                placeholder="Key"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Type" prop="type" size="small">
                            <el-select
                                filterable
                                v-model="editForm.type"
                                placeholder="Please Select"
                            >
                                <el-option
                                    v-for="item in typeList"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-top: 10px" v-if='["Drop-down","Mult-select","Radio"].includes(editForm.type)'>
                        <div class="table">
                            <el-table
                                border
                                :data="editForm.values"
                                ref="attributes"
                                highlight-current-row
                                max-height="500px"
                            >
                                <el-table-column label="Name" align="center">
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: true }]"
                                            :prop="
                                                'values.' +
                                                scope.$index +
                                                '.name'
                                            "
                                        >
                                            <el-input
                                                clearable
                                                placeholder="Name"
                                                maxlength="100"
                                                size="small"
                                                v-model="scope.row.name"
                                            ></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center">
                                    <template slot="header" slot-scope="scope">
                                        Operation
                                        <el-button
                                            type="text"
                                            icon="el-icon-plus"
                                            @click="addItem(scope)"
                                        ></el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-button
                                            type="text"
                                            icon="el-icon-minus"
                                            style="color: red"
                                            @click="removeItem(scope)"
                                        ></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
export default {
    data() {
        return {
            editForm: {
                username: "",
                email: "",
                mobile: "",
                need_tag: "",
                status: "",
                values: [],
            },
            typeList: [
                "Field",
                "Area",
                "Drop-down",
                "Mult-select",
                "File",
                "Radio",
                "Date",
                "Datetime",
            ],
        };
    },
    methods: {
        save() {
            this.loading = true;
            cmofferApi
                .metafileds(
                    {
                        ...this.editForm,
                        values: ["Drop-down","Mult-select","Radio"].includes(this.editForm.type) ? this.editForm.values : [{name: ""}]
                    },
                    "post",
                    this.tableItem.id
                )
                .then((res) => {
                    this.loading = false;
                    this.$message.success(
                        this.$i18n.locale == "zh" ? "成功" : "Success"
                    );
                    this.closeDialog();
                    this.$parent[this.funcName]();
                });
        },
        closeDialog() {
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
        },
        async initialize() {},
        addItem(row) {
            this.emptyTableItem = {
                sku: "", //sku *
                goods_num: "", //数量 *
                goods_price: "", //单价 *
                goods_discount: "", //折扣
                itemID: "", //itemID
            };
            let dataTemplate = JSON.parse(JSON.stringify(this.emptyTableItem));
            if (this.editForm.values.length == 0 || row) {
                this.editForm.values.push(dataTemplate);
            }
        },
        removeItem(scope) {
            if (this.editForm.values.length > 1) {
                for (let i in this.editForm.values) {
                    if (i == scope.$index) {
                        this.editForm.values.splice(i, 1);
                    }
                }
            } else {
                return false;
            }
        },
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    watch: {
        editVisible() {
            if (this.editVisible) {
                // console.log("this.tableItem: ", this.tableItem);
                this.editForm = {
                    ...this.tableItem,
                    values: this.tableItem.metafields_value
                };
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.edit {
    ::v-deep .container {
        .table {
            .el-form-item {
                margin-bottom: 0;
            }
        }
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }
        .el-select {
            width: 100%;
        }
        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
}
</style>
